import * as constants from '../constants';

export default function(state = [], action) {
  switch (action.type) {
    case constants.GET_MORETOEXPLORECOLLECTION_SUCCESS:
      return Object.assign({}, state, {
        moreToExploreCollection: action.moreToExploreCollection.data || [],
        isRefreshRequired: false,
      });
    case constants.POST_MORETOEXPLORE_SUCCESS:
    case constants.PATCH_MORETOEXPLORE_SUCCESS:
      return Object.assign({}, state, {
        isRefreshRequired: true,
      });
    case constants.GET_MORETOEXPLORE_SUCCESS:
      return Object.assign({}, state, {
        moreToExplore: action.moreToExplore.data || {},
        isRefreshRequired: false,
      });
    case constants.GET_MORETOEXPLORECOLLECTION_ERROR:
    case constants.GET_MORETOEXPLORE_ERROR:
    case constants.POST_MORETOEXPLORE_ERROR:
    case constants.PATCH_MORETOEXPLORE_ERROR:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}
